import styled from "styled-components";
import { EyeFilled } from "@ant-design/icons";

export const VisibleIcon = styled(EyeFilled)`
  color: ${({ theme }) => theme.colors.blueDianne};
`;
